<template>
  <div class="fin-etf-screener">
    <fin-work-in-progess-page v-if="etfScreenerDisabled"
                              title="ETF-Screener"/>

    <fin-data-loader :resolver="fetchData" v-else-if="!$route.params.id">
      <template #content="{data}">
        <fin-screener-list
          v-model="etfScreenerList"
          :create-screener="createScreener"
          :delete-screener="deleteScreener"
          :noData="noData"
          :update-screener-name="updateScreenerName"
          description="Durchsuche unsere Wertpapieruniversum nach den besten ETFs für deine Strategie"
          title="ETF-Screener"
          @edit="onEdit"
          @execute="onExecute"/>
      </template>
    </fin-data-loader>
    <router-view v-else/>
  </div>

</template>

<script>
import { finEtfScreenerAPI, finUserAPI, finEtfAPI} from '@/js/finAPI'
import { mapGetters } from 'vuex'
import FinScreenerList from '@/components/pages/finTools/finScreener/ScreenerList/index'
import FinDataLoader from '@/components/common/DataLoader/index'
import { EventBus } from '@/plugins/fincraft'
import assetClassesMock from '@/mocks/AssetClassesScreener'
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: 'fin-etfScreener',
  components: {FinWorkInProgessPage, FinDataLoader, FinScreenerList},
  data() {
    return {
      etfScreenerDisabled: process.env.VUE_APP_ETFSCREENER_DISABLED === 'true',
      etfScreenerList: undefined,
       noData: 'Du hast noch keinen eigenen ETF-Screener angelegt.',
      etfAssetClasses: assetClassesMock.items.filter(item => item.id !== 'SHARE')
    }
  },
  computed: mapGetters('auth', ['userId']),
  methods: {
    onEdit (screener) {
        this.$router.push({
          name: 'etfScreenerEdit',
          params: { id: screener.id }
        }).catch(err => {
          // ignore redundant navigation exception
        })
      },
      onExecute (screener) {
        this.$router.push({
          name: 'etfScreenerExecute',
          params: { id: screener.id }
        })
      },
      async fetchData () {
        this.etfScreenerList = await finUserAPI.getEtfScreeners()
      },
      async createScreener (name) {
        const hits = await finEtfAPI.totalEtfs(this.etfAssetClasses[0].id)
        return await finEtfScreenerAPI.saveEtfScreenerConfiguration(
          this.createNewScreenerObject(name,hits)
        )
      },
      async updateScreenerName (screener, name) {
        await finEtfScreenerAPI.renameEtfScreenerConfiguration({
          id: screener.id,
          name: name
        })
        this.$set(screener, 'name', name)
      },
      async deleteScreener (screener) {
        await finEtfScreenerAPI.deleteEtfScreenerConfiguration(screener).then(result => {
          this.$toasted.global.finToast({
            message: 'Dein Screener %name% wurde gelöscht.',
            placeholders: [{name: 'name', content: result.name}],
            type: 'success',
          })
        }).catch(error => {
          console.error("deleteScreener error", error)
          this.$toasted.global.finToast({
            message: 'Dein Screener %name% konnte nicht gelöscht werden.',
            placeholders: [{name: 'name', content: screener.name}],
            type: 'error',
          })
        })
      },
      createNewScreenerObject (name, hits=0) {
        return {
          name: name,
          user: {
            id: this.userId
          },
          lastHits: hits,
          // selected asset class
          assetClass: {id: this.etfAssetClasses[0].id},
          // TODO nice-to-have selected index
          screenerConfigurationAssetClassId: this.etfAssetClasses[0].id,
          rangeFilters: {
            items: []
          },
          valueFilters: {
            items: []
          },
          resultColumns: []
        }
      }
  },
  mounted() {
    EventBus.$on('edit', this.onEdit)
  },
  beforeDestroy() {
    EventBus.$off('edit', this.onEdit)
  }
}

</script>
